var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_vm._v(" 你最喜欢的科目? "),_c('AnswerOptions',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }